module.exports = __webpack_public_path__ + "img/PriceQuotations_Canceled.693ce748.svg";